// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CodeSandboxCircleFilledSvg from "@fishx/icons-svg/es/asn/CodeSandboxCircleFilled";
import FishxIcon from '../components/FishxIcon';

var CodeSandboxCircleFilled = function CodeSandboxCircleFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: CodeSandboxCircleFilledSvg
  }));
};

CodeSandboxCircleFilled.displayName = 'CodeSandboxCircleFilled';
export default React.forwardRef(CodeSandboxCircleFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/CodeSandboxCircleFilled.js
// module id = 2272
// module chunks = 0